import {
  computeNativeId,
  type NativeId,
} from '@packages/systems/core/utils/NativeIdUtils';
import type {EnvironmentContextType} from '@packages/systems/wfdl';
import {getOverlayDomId} from '../shared/ids';

const POPOVER_DOM_ID_PREFIX = 'w-popover-';

export const getPopoverDomId = (
  runtimeNativeIdPath: readonly NativeId[]
): string => getOverlayDomId(POPOVER_DOM_ID_PREFIX, runtimeNativeIdPath);

export const getPopoverElementDomId = (
  elementId: string,
  nativeIdPath: readonly NativeId[],
  environmentContext: EnvironmentContextType
): string =>
  getPopoverDomId([
    ...nativeIdPath,
    computeNativeId(elementId, environmentContext),
  ]);
